import React from 'react';
import SearchRow from 'views/AddNewServices/AddSingleService/tabs/common/SearchRow';
import CustomSearch from 'components/CustomSearch/CustomSearch';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/addLineDialogStyle';
import { makeStyles } from '@material-ui/core';
import { SingleUser } from 'utils/api/models/users/singleUser';

// @ts-ignore
const useStyles = makeStyles(styles);

interface INumberTabProps {
	numbers: Array<string>;
	setSelectedNumber: React.Dispatch<React.SetStateAction<string>>;
	selectedNumber: string;
	users: SingleUser[];
	selectedUser: SingleUser | null;
	setSelectedUser: React.Dispatch<React.SetStateAction<SingleUser | null>>;
	loading: boolean;
	setSearch: (event: any) => void;
}

const NumberTab = ({
	numbers,
	setSelectedNumber,
	selectedNumber,
	users,
	setSelectedUser,
	selectedUser,
	loading,
	setSearch,
}: INumberTabProps) => {
	const classes = useStyles();

	return (
		<div className={classes.smWidth}>
			<div className={classes.numberSearchWrapper}>
				<CustomSearch
					elements={numbers.map((number) => ({
						id: number,
						value: number,
						content: <SearchRow text={number} />,
					}))}
					id="phoneNumberSearch"
					label={translate('phoneNumber')}
					elementSelected={(number) => setSelectedNumber(number?.value || null)}
					loading={loading}
					onChange={(event: string) => setSearch(event)}
					selectedElement={
						selectedNumber
							? {
									id: selectedNumber,
									value: selectedNumber,
							  }
							: null
					}
					areMoreOptionsAvailable={true}
				/>
			</div>
			<div>
				<CustomSearch
					elements={users.map((user) => ({
						...user,
						id: user.userId,
						value: user.userName,
						content: <SearchRow text={user.userName} />,
					}))}
					id="userSearch"
					label={translate('user.name.optional')}
					elementSelected={(user) => setSelectedUser(user)}
					selectedElement={selectedUser as any}
				/>
			</div>
		</div>
	);
};

export default NumberTab;
